import { render, staticRenderFns } from "./InstallmentsOptions.vue?vue&type=template&id=28cc6d8b"
import script from "./InstallmentsOptions.vue?vue&type=script&lang=js"
export * from "./InstallmentsOptions.vue?vue&type=script&lang=js"
import style0 from "./InstallmentsOptions.vue?vue&type=style&index=0&id=28cc6d8b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FlipBackTransition: require('/home/jenkins/workspace/m-front-end-chapter_voyager_main/frontend/components/FlipBackTransition.vue').default})
